import BigNumber from 'bignumber.js'

import { CurrencyAddress, CurrencyModel } from '@root/entities/currency'
import { currencyRegistry } from '@root/entities/currency/atoms'
import { Network } from '@root/entities/network'

import type { UserApi } from '@root/shared/api'
import type { TokenLogosHost } from '@root/shared/models'

export type BestDeal = {
  currency: CurrencyModel

  closePriceUsd: BigNumber
  closePriceNative: BigNumber

  entryPriceUsd: BigNumber
  entryPriceNative: BigNumber

  totalInvestedUsd: BigNumber
  totalInvestedNative: BigNumber

  totalSoldUsd: BigNumber
  totalSoldNative: BigNumber

  totalProfitUsd: BigNumber
  totalProfitNative: BigNumber

  date: Date
  closeDate: Date
  pnlNative: BigNumber
  pnlUsd: BigNumber
  pnlPercents: number
}

export const fromDto = (
  dto: UserApi.UserProfileBestDealDto,
  tokenLogosHost: TokenLogosHost,
): BestDeal => {
  const quoteCurrency = currencyRegistry.getOrCreate(
    CurrencyAddress(dto.toTokenMeta.address),
    Network.fromDto(dto.toTokenMeta.network),
    () => CurrencyModel.fromTokenMeta(dto.toTokenMeta, tokenLogosHost),
  )

  return {
    date: new Date(dto.date),
    closeDate: new Date(dto.closeDate),
    entryPriceUsd: BigNumber(dto.entryPrice.usd),
    entryPriceNative: BigNumber(dto.entryPrice.native),

    closePriceUsd: BigNumber(dto.closePrice.usd),
    closePriceNative: BigNumber(dto.closePrice.native),

    totalInvestedUsd: BigNumber(dto.totalInvest.usd),
    totalInvestedNative: BigNumber(dto.totalInvest.native),

    totalSoldUsd: BigNumber(dto.totalSold.usd),
    totalSoldNative: BigNumber(dto.totalSold.native),

    totalProfitUsd: BigNumber(dto.totalProfit.usd),
    totalProfitNative: BigNumber(dto.totalProfit.native),

    pnlNative: BigNumber(dto.pnlNative),
    pnlPercents: BigNumber(dto.pnlPercent).toNumber(),
    pnlUsd: BigNumber(dto.pnlUsd),

    currency: quoteCurrency,
  }
}
